module.exports = __webpack_public_path__ + "static/media/1moneysign-gray.968463a3.svg";